import * as React from 'react';

import { DataTable } from '@/components/dataTable';
import { useDataTable } from '@/components/dataTable/hooks/use-data-table';
import { DataTableToolbar } from '@/components/dataTable/ToolBar';

import { PointsBalanceStatementData } from '@/services/pointsBalanceStatement/pointsBalanceStatement.types';
import { getColumns } from './Column';
import { useDynamicLocale } from '@/hoslog-intl';

export function PointsBalanceStatementTable({ data }: { data: PointsBalanceStatementData[] }) {
  const { t } = useDynamicLocale();
  const columns = React.useMemo(() => getColumns(t), [t]);

  const { table } = useDataTable({
    data,
    columns,
    pageCount: 0,
    initialState: {
      sorting: [{ id: 'id', desc: true }],
      columnPinning: { right: ['actions'] },
    },
    meta: {
      title: t('pointManagement.sidebar.menu.pointsBalanceStatement'),
    },
    getRowId: (originalRow) => String(originalRow.id),
    shallow: false,
    clearOnDefault: true,
  });

  return (
    <>
      <DataTable table={table}>
        <DataTableToolbar />
      </DataTable>
    </>
  );
}
